import React from 'react';
import { IPreloadCacheContext } from 'framework/context/IPreloadCacheContext';

export const RecupelDefaultCacheContext = React.createContext<IPreloadCacheContext<string>>(undefined as any);
